import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LineCharts } from "../../../../Constant";
import { LINE_CHART_DATA, LINE_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const LineChart = () => {
  return (
    <Col sm="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={LineCharts} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="line-chart">
            <Chart chartType="Line" width="100%" height="5
            00px" data={LINE_CHART_DATA} options={LINE_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineChart;
